import headerStyle from "./Header.module.css";

import edenredLogo from "../assets/images/edenred-logo.svg";
import weareoneLogo from "../assets/images/weareone-logo.svg";
function Header() {
    return(
        <img src={'/images/header.png'} alt={'header'} style={{width:'100vw'}}/>
    )
}

export default Header;